// src/views/scannedData/SelectedDataDisplay.js
import PropTypes from "prop-types";

export default function SelectedDataDisplay({ selectedData }) {
  if (!selectedData) return null;

  const address =
    selectedData.editedAddress ||
    selectedData.googleMapAddress ||
    "";

  return (
    <div id="selected-data-box">
      <h3>Selected Data</h3>

      <p>
        <strong>QR Data:</strong> {selectedData.qrcodeData}
      </p>

      <p>
        <strong>Address:</strong>{" "}
        {address ? (
          <a
            href={`https://www.google.com/maps?q=${encodeURIComponent(address)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="map-link"
          >
            {address}
          </a>
        ) : (
          "N/A"
        )}
      </p>

      {selectedData.coordinates && (
        <p>
          <strong>Coordinates:</strong>{" "}
          {selectedData.coordinates.x},{" "}
          {selectedData.coordinates.y}
        </p>
      )}

      {selectedData.urlToReadImage && (
        <p>
          <strong>Image:</strong>{" "}
          <a
            href={selectedData.urlToReadImage}
            target="_blank"
            rel="noopener noreferrer"
          >
            View
          </a>
        </p>
      )}
      {selectedData.note && (
        <p>
          <strong>Note:</strong> {selectedData.note}
        </p>
      )}
    </div>
  );
}

SelectedDataDisplay.propTypes = {
  selectedData: PropTypes.object,
};
